import { createSelector } from 'reselect';
import get from 'lodash/get';
import { SCOPE } from './types';

const selector = state => get(state, SCOPE);

export default selector;

export const birdChartDataSelector = createSelector(
  selector,
  birdChartStore => get(birdChartStore, 'response') || {},
);

export const birdChartSliceDataSelector = createSelector(
  selector,
  birdChartStore => get(birdChartStore, 'sliceResponse') || null,
);

export const sliceIntervalSelector = createSelector(
  selector,
  birdChartStore => ({
    from: get(birdChartStore, 'sliceFrom', ''),
    to: get(birdChartStore, 'sliceTo', ''),
  }),
);
